/**
 * @generated SignedSource<<d7aed557454ed6ab457e44b02e86668a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditEmailTemplateScreen_EmailTemplateFragment$data = {
  readonly id: string;
  readonly template: {
    readonly body: string;
    readonly key: string;
    readonly previewText: string;
    readonly subject: string;
    readonly variables: ReadonlyArray<string>;
  };
  readonly " $fragmentType": "EditEmailTemplateScreen_EmailTemplateFragment";
};
export type EditEmailTemplateScreen_EmailTemplateFragment$key = {
  readonly " $data"?: EditEmailTemplateScreen_EmailTemplateFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditEmailTemplateScreen_EmailTemplateFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditEmailTemplateScreen_EmailTemplateFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EmailTemplate",
      "kind": "LinkedField",
      "name": "template",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "subject",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "previewText",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "body",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "variables",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PersonalizedEmailTemplate",
  "abstractKey": null
};

(node as any).hash = "caf55fad662fdd72bd2024878f409221";

export default node;
